

































import { Component, Vue } from 'vue-property-decorator';
import PasswordSetupForm from '@/components/auth/recovery/password-setup/PasswordSetupForm.vue';

@Component({
  components: {
    PasswordSetupForm,
  },
})
export default class PasswordSetup extends Vue {
  email: string = '';
  token: string = '';

  mounted() {
    const locale = this.$route.query.locale as string;
    if (locale) {
      this.$i18n.locale = locale;
    }

    this.email = this.$route.query.email as string;
    this.token = this.$route.query.token as string;

    if (!this.email || !this.token) {
      this.$router.push({ name: 'login' });
    }
  }

  success(form: any) {
    this.$router.push({
      name: 'login',
      query: { email: form.email },
      params: { message: this.$t('passwordSetup.success-message') as string },
    });
  }
}
